import { useGraphql } from 'utils/hooks/useGraphql';
import { isUndefined } from 'utils/tsHelpers';

import { DEFAULT_CAMPAIGNS, USE_CAMPAIGNS_HOOK_QUERY } from './constants';
import { UseCampaignsHookInputs, UseCampaignsHookOutput, UseCampaignsQueryData } from './types';
import { useCampaignsVariables } from './useCampaignsVariables';

export const useCampaigns = ({
  search,
  ids,
  page = 0,
  isRecurring = false,
}: UseCampaignsHookInputs): UseCampaignsHookOutput => {
  const variables = useCampaignsVariables(search, ids, page, isRecurring);
  const skip = ids?.length === 0;
  const {
    data: { campaigns: data } = {},
    error: didError,
    isLoading,
  } = useGraphql<UseCampaignsQueryData>(USE_CAMPAIGNS_HOOK_QUERY, {
    variables,
    skip,
  });
  return {
    campaigns: isUndefined(data?.results) || skip ? DEFAULT_CAMPAIGNS : data.results,
    campaignsCount: data?.info?.count || 0,
    didError,
    isLoading,
  };
};
